(() => {
  const selectors = {
    slider: "[data-ea-pcard-slider]",
    slide: ".ea-pcard6-slider__slide",
    button: ".ea-pcard6-slider__button",
  };

  const setActiveSlide = (slider, nextIndex) => {
    const slides = Array.from(slider.querySelectorAll(selectors.slide));
    if (!slides.length) return;

    const maxIndex = slides.length - 1;
    let index = nextIndex;

    if (index < 0) index = maxIndex;
    if (index > maxIndex) index = 0;

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    slider.dataset.activeIndex = String(index);
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest(selectors.button);
    if (!button) return;

    const slider = button.closest(selectors.slider);
    if (!slider) return;

    event.preventDefault();

    const currentIndex = Number(slider.dataset.activeIndex || 0);
    const direction = button.dataset.direction === "prev" ? -1 : 1;
    setActiveSlide(slider, currentIndex + direction);
  });

  document.querySelectorAll(selectors.slider).forEach((slider) => {
    setActiveSlide(slider, Number(slider.dataset.activeIndex || 0));
  });
})();
